<template>
    <ui-modal icon-circle :title="form.data.modal.title" :name="name" icon="fal fa-paper-plane" size="xs" >
        <ui-overlay-load v-if="load" />
        <section class="modal-content-line">
            <form>
                <div class="title"><label>{{form.data.modal.title}}</label></div>
                <div class="text"><label>{{form.data.modal.text}}</label></div>
            </form>
        </section>

        <template #footer>
            <div class="buttons">
                <ui-modal-cancel-button :modal-name="$mx_getModalName"
                >Cancelar</ui-modal-cancel-button
                >
                <ui-button 
                    v-if="form.data.button.length === 1"
                    :disabled="!canSubmit"
                    type="button"
                    design="md success"
                    @click="submit(form.data.button[0].id)"
                >
                    {{form.data.button[0].text}}
                </ui-button>

                <ui-menu-card v-else :button-icon="false" > 
                    <template #button="{ toggleClick }" >
                        <ui-button  type="button" design="md success" @click="toggleClick" >
                            Procedimentos <i class="fas fa-caret-down"/>
                        </ui-button>
                    </template>
                    <button 
                        v-for="btn in form.data.button" 
                        :key="btn.id" 
                        :disabled="!canSubmit" 
                        type="button" 
                        @click="submit(btn.id)"
                    >{{btn.text}}</button>
                </ui-menu-card>
            </div>
        </template>
    </ui-modal>
</template>
<script>
    import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
    import { uiButton } from '@/components/ui/buttons'
    import { uiMenuCard, uiOverlayLoad } from "@/components/ui"

    import { deal } from '@/services/axios'

    import { mapGetters } from 'vuex'
    import { modalMixin } from '@/mixins'
    import { $mx_toastFormatMessages } from '@/mixins/util'

    const defaultFormData = () => ({
        dealId: null,
        procedureId: null,
        modal: {
            title: 'Carregando',
            text: 'Carregando'
        },
        button: []
    })

    export default {
        name: 'ui-procedure-modal',
        components: {
            uiModal,
            uiButton,
            uiMenuCard,
            uiOverlayLoad,
            uiModalCancelButton
        },

        mixins: [modalMixin],

        props: {
            name: {
                type: String,
                require: true
            },

            successEvent: {
                type: String,
                require: true
            }
        },
       
       data(){
            return {
                form: {
                    data: {
                        ...defaultFormData()
                    },
                },
                load: false,
            }
        },

        mounted(){
            this.$root.$on('modal-open-' + this.name, (data) => {
                this.reset()
                this.load = true
                deal.get('', data.dealId)
                    .then(res => {
                        if (res.status === 200) {
                            let procButtons = res.data.procedure

                            if (procButtons.length > 0) {
                                procButtons.forEach(e => {
                                    if (e.id === parseInt(data.id)) {
                                        this.$set( this.form, 'data', {
                                            dealId: data.dealId,
                                            procedureId: data.id,
                                            modal: {
                                                title: e.title,
                                                text: e.text
                                            },
                                            button: e.buttons,
                                        })
                                    }
                                });
                            }
                        }
                    })  
                    .catch(error => {
                        if (error.data && error.data.msg){
                            this.$toastr.s(error.data.msg)
                        }
                    })
                    .finally(() => ( this.load = false ) )
            })
        },

        beforeDestroy(){
            this.$root.$off('modal-open-' + this.name)
        },

        computed: {
            ...mapGetters('auth', {
                user: 'getUser'
            }),

            canSubmit(){
                return this.form.data.dealId
            }
        },

        methods: {
            reset(){
                this.$set( this.form, 'data', { ...defaultFormData() } )
            },

            submit(id){
                this.load = true
                if (!this.canSubmit) return

                deal.procedure(this.form.data.dealId, {
                    button_id: id
                })
                    .then(response => {
                        if (response.data.msg) {
                            this.$toastr.s(response.data.msg)
                        }
                        this.load = false
                        this.$root.$emit('modal-close-' + this.name)
                        this.$root.$emit(this.successEvent)
                    })
                    .catch(error => {
                        this.load = false
                        $mx_toastFormatMessages(error)
                    })
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import 'styles.styl'
</style>